"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useShowDataGridFooter = function (showPagination, footerElement) {
    var showDataGridFooter = (0, react_1.useMemo)(function () { return !!(showPagination || footerElement); }, [showPagination, footerElement]);
    return showDataGridFooter;
};
exports.default = useShowDataGridFooter;
